import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { MDBCol, MDBRow } from "mdbreact";

import { scrollTop } from "../../../functions";
import { formatDefaultDate } from "../../../utils/formatDate";

import "./styles.css";

const NewsCard = ({ img, date, author, title, subtitle, path }) => {
  return (
    <div className="news-card">
      <Link to={path} onClick={scrollTop}>
        <MDBRow>
          <MDBCol lg="4" md="6" sm="12">
            <img src={img} alt="WorkImage" />
          </MDBCol>
          <MDBCol lg="8" md="6" sm="12" className="news-card-content">
            <h6>
              {formatDefaultDate(date || "2020-06-17")} - Publicado por {author}
            </h6>
            <div className="news-card-caption">
              <h3>{title}</h3>
              <p>{subtitle}</p>
            </div>
          </MDBCol>
        </MDBRow>
      </Link>
    </div>
  );
};

NewsCard.propTypes = {
  img: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default NewsCard;
